import { useMediaQuery } from '@mui/material';
import { useTheme } from '@mui/styles';
import useWindowSize from './useWindowSize';

export type ScreenSize = 'mobile' | 'desktop';

export const useScreenSize = () => {
  useWindowSize();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'), { noSsr: true });
  if (isMobile) {
    return 'mobile';
  }
  return 'desktop';
};
